import { computed } from 'vue';
import { useProfileList } from '@models/profile/profileList';

export function useInsight() {
    const { profileListWithoutDemo } = useProfileList();
    const hasInsightProfile = computed(() => {
        return (
            // !import.meta.env.VITE_DISABLE_INSIGHT &&
            profileListWithoutDemo.value?.some(profile => profile.pteEnabled === 1)
        );
    });

    return {
        hasInsightProfile
    };
}
